import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { __rest as e } from "../_virtual/_tslib.js";
import { jsx as r, jsxs as o } from "react/jsx-runtime";
import a, { css as n } from "styled-components";
import { calculateRem as t } from "@vds-core/utilities";
import { ColorTokens as l } from "@vds-tokens/color";
import { FormControlsTokens as i } from "@vds-tokens/form-controls";
import { AccessibilityTokens as d } from "@vds-tokens/accessibility";
var c = r("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.6 21.6",
    children: r("path", {
      d: "M8,19.1l-7-7l2.5-2.5L8,14L18.1,3.8l2.5,2.5L8,19.1z"
    })
  }),
  u = {
    disabled: !1,
    error: !1,
    height: 20,
    width: 20,
    surface: "light",
    hovered: !1,
    calculateBorderWidth: function calculateBorderWidth(_ref) {
      var e = _ref.selected;
      return e ? 0 : t(d.focusring.borderwidth.value);
    },
    calculateCheckboxBackgroundColor: function calculateCheckboxBackgroundColor(_ref2) {
      var e = _ref2.disabled,
        r = _ref2.selected,
        o = _ref2.surface,
        a = _ref2.$error;
      return e && r ? "dark" === o ? l.interactive.disabled.ondark.value : l.interactive.disabled.onlight.value : r ? "dark" === o ? l.background.primary.inverse.dark.value : l.background.primary.inverse.light.value : a && !e ? "dark" === o ? l.feedback.error.background.ondark.value : l.feedback.error.background.onlight.value : "transparent";
    },
    calculateBorderColor: function calculateBorderColor(_ref3) {
      var e = _ref3.disabled,
        r = _ref3.$error,
        o = _ref3.surface,
        a = _ref3.$hovered,
        n = _ref3.selected;
      return e ? "dark" === o ? l.interactive.disabled.ondark.value : l.interactive.disabled.onlight.value : r ? "dark" === o ? l.feedback.error.ondark.value : l.feedback.error.onlight.value : a && !n ? "dark" === o ? l.elements.secondary.ondark.value : l.elements.secondary.onlight.value : "dark" === o ? i.color.border.ondark.value : i.color.border.onlight.value;
    },
    calculateBoxShadow: function calculateBoxShadow(_ref4) {
      var e = _ref4.$hovered,
        r = _ref4.disabled,
        o = _ref4.surface,
        a = _ref4.$error,
        n = _ref4.selected;
      return e && !r ? " 0 0 0 ".concat(t(i.border.width.value), " ").concat(function (e, r, o) {
        return r ? "dark" === e ? l.feedback.error.ondark.value : l.feedback.error.onlight.value : o ? "dark" === e ? i.color.border.hover.ondark.value : i.color.border.hover.onlight.value : "dark" === e ? l.elements.secondary.ondark.value : l.elements.secondary.onlight.value;
      }(o, a, n)) : "none";
    }
  },
  s = n(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  left: ", ";\n  position: absolute;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  top: 50%;\n"])), t(10)),
  h = a.div.withConfig({
    displayName: "HitArea",
    componentId: "VDS__sc-acu31g-0"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  cursor: ", ";\n  display: inline-block;\n  height: ", ";\n  width: ", ";\n"])), s, function (_ref5) {
    var e = _ref5.disabled;
    return e ? "default" : "pointer";
  }, t(44), t(44)),
  v = a.span.withConfig({
    displayName: "StyledWrapper",
    componentId: "VDS__sc-acu31g-1"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: inline-block;\n  content: '';\n  height: ", ";\n  left: 50%;\n  position: relative;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: ", ";\n"])), t(20), t(20)),
  b = a.span.withConfig({
    displayName: "StyledInner",
    componentId: "VDS__sc-acu31g-2"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  left: 50%;\n  box-sizing: border-box;\n  width: ", ";\n  height: ", ";\n  transform: translate(-50%, -50%);\n  background-color: ", ";\n  border-style: solid;\n  border-color: ", ";\n  border-radius: ", ";\n  border-width: ", ";\n  box-shadow: ", ";\n  ", "\n"])), t(20), t(20), function (r) {
    var o = r.$calculateCheckboxBackgroundColor,
      a = e(r, ["$calculateCheckboxBackgroundColor"]);
    return null == o ? void 0 : o(a);
  }, function (r) {
    var o = r.$calculateBorderColor,
      a = e(r, ["$calculateBorderColor"]);
    return null == o ? void 0 : o(a);
  }, function (_ref6) {
    var e = _ref6.$borderRadius;
    return e;
  }, function (r) {
    var o = r.$calculateBorderWidth,
      a = e(r, ["$calculateBorderWidth"]);
    return null == o ? void 0 : o(a);
  }, function (r) {
    var o = r.$calculateBoxShadow,
      a = e(r, ["$calculateBoxShadow"]);
    return null == o ? void 0 : o(a);
  }, function (_ref7) {
    var e = _ref7.surface,
      r = _ref7.disabled;
    return !r && "\n    &:active {\n      border-color: ".concat("dark" === e ? l.elements.primary.ondark.value : l.elements.primary.onlight.value, ";\n      &:hover {\n        box-shadow: 0 0 0 ").concat(t(i.border.width.value), " ").concat("dark" === e ? l.elements.primary.ondark.value : l.elements.primary.onlight.value, "\n      }\n    }\n  ");
  }),
  f = a.div.withConfig({
    displayName: "IconSVGWrapper",
    componentId: "VDS__sc-acu31g-3"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  height: ", ";\n  width: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  ", ";\n  &:active,\n  &:focus {\n    outline: none;\n  }\n  svg {\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (_ref8) {
    var e = _ref8.$iconSize;
    return t(e);
  }, function (_ref9) {
    var e = _ref9.$iconSize;
    return t(e);
  }, function (_ref0) {
    var e = _ref0.$iconSize;
    return t(e);
  }, function (_ref1) {
    var e = _ref1.$iconSize;
    return t(e);
  }, function (_ref10) {
    var e = _ref10.tabIndex;
    return e && e < 0 && "\n    outline: none;\n    pointer-events: none;\n  ";
  }, function (_ref11) {
    var e = _ref11.$iconColor;
    return e;
  }),
  $ = function $(a) {
    var n = a.selected || !1,
      t = a.calculateBoxShadow,
      i = a.calculateBorderColor,
      d = a.calculateCheckboxBackgroundColor,
      u = a.calculateBorderWidth,
      s = a.borderRadius,
      $ = a.hovered,
      k = a.error,
      m = e(a, ["calculateBoxShadow", "calculateBorderColor", "calculateCheckboxBackgroundColor", "calculateBorderWidth", "borderRadius", "hovered", "error"]);
    return o(v, {
      children: [r(h, {
        $error: k,
        disabled: a.disabled,
        surface: a.surface
      }), r(b, Object.assign({}, m, {
        $calculateBoxShadow: t,
        $calculateBorderColor: i,
        $calculateCheckboxBackgroundColor: d,
        $calculateBorderWidth: u,
        $borderRadius: s,
        $hovered: $,
        $error: k,
        disabled: a.disabled,
        surface: a.surface,
        className: "styledInner",
        children: n && r(f, {
          "aria-hidden": !0,
          $iconSize: 12,
          tabIndex: -1,
          $iconColor: "dark" === a.surface ? l.elements.primary.inverse.ondark.value : l.elements.primary.inverse.onlight.value,
          children: c
        })
      }))]
    });
  };
$.defaultProps = u;
export { $ as default };